import { Box, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { NoteDTO } from 'wisestep-api';
import { WsListingLoader, WsTypography, WsIconNoUserGeneric } from 'wisestep-base';

import NoDataFoundCard from '../../../components/noDataFoundCard/NoDataFoundCard';

import NotesCard from './NotesCard';

interface NotesProps {
  getNote: (noteId: string) => void;
  isLoading?: boolean;
  notes: NoteDTO[];
  isAdding?: boolean;
}

const NotesLeftPanel = ({ getNote, notes, isLoading, isAdding }: NotesProps) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  useEffect(() => {
    if (isAdding) {
      setSelectedIndex(0);
    }
  }, [isAdding]);

  return (
    <Box>
      {isLoading ? (
        <Grid item xs={12}>
          <WsListingLoader />
        </Grid>
      ) : notes.length > 0 ? (
        notes.map((note, index) => (
          <NotesCard
            key={note.id}
            note={note}
            onClick={() => {
              setSelectedIndex(index);
              getNote(note.id);
            }}
            isSelected={selectedIndex === index}
          />
        ))
      ) : (
        <Grid item xs={12} mt={2}>
          <NoDataFoundCard
            text=""
            icon={<WsIconNoUserGeneric />}
            subElement={<WsTypography>No Notes available</WsTypography>}
          />
        </Grid>
      )}
    </Box>
  );
};
export default NotesLeftPanel;
